module.exports = __webpack_public_path__ + "img/call.8c06b9ed.jpg";